@if (isMobile()) {
    <app-mobile-dre
        [loading]="loading"
        [report]="report"
        [company]="company"
        [accordionState]="accordionState"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-mobile-dre>
} @else {
    <app-desktop-dre
        [loading]="loading"
        [accordionState]="accordionState"
        [report]="report"
        [company]="company"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-desktop-dre>
}
